// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_gdT","cls2":"NewCitationPing-cls2_bpe NewCitationPing-cls1_gdT"};